import script from "./searchdetails.vue?vue&type=script&setup=true&lang=js"
export * from "./searchdetails.vue?vue&type=script&setup=true&lang=js"

import "./searchdetails.vue?vue&type=style&index=0&id=67045019&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67045019"]])

export default __exports__